import StateManager from "../scuba/StateManager";
import LayoutManager from "../scuba/LayoutManager";

/* --------------------------------------------------

                      PIPELINE

-------------------------------------------------- */

/* -------------------------
    INIT
------------------------- */

// Lecture cookies (pour WPML)
function getCookie(c_name) {
  var c_value = document.cookie,
      c_start = c_value.indexOf(" " + c_name + "=");
  if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
  if (c_start == -1) {
      c_value = null;
  } else {
      c_start = c_value.indexOf("=", c_start) + 1;
      var c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) {
          c_end = c_value.length;
      }
      c_value = unescape(c_value.substring(c_start, c_end));
  }
  return c_value;
}


$(window).on(StateManager.CONTENT_READY, function (event, node) {

  console.log("PIPELINES");

  $(node)
    .find(".pipeline")
    .each(function (i, elem) {

      $(elem).find(".toggle_link")
        .each(function (j, link) {

            $(link).on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(link).empty();
                if ( $(elem).find(".product_description").is(":visible") ) {
                  if ( getCookie('wp-wpml_current_language') == 'fr' ) {
                    $(link).append("Plus de détails"); 
                  } else {
                    $(link).append("More details"); 
                  }
                } else {
                  if ( getCookie('wp-wpml_current_language') == 'fr' ) {
                    $(link).append("Moins de détails");
                  } else {
                    $(link).append("Less details");
                  }
                }
                $(elem).find(".product_description").toggle();

              });
        
        });

    });
});



// WEBPACK FOOTER //
// ./scripts/components/Pipeline.js